import React from 'react';
import { lazyImport } from '@/utils';
import { RouteProps } from './type';

const { BasicLayout } = lazyImport(() => import('@/layout'), 'BasicLayout');
const { AppLayout } = lazyImport(() => import('@/layout'), 'AppLayout');
const { RootLayout } = lazyImport(() => import('@/layout'), 'RootLayout');
const { ApplicationManagement } = lazyImport(
  () => import('@/pages/AppManagement'),
  'ApplicationManagement'
);

const { ApplicationCreate } = lazyImport(() => import('@/pages/AppCreate'), 'ApplicationCreate');
const { TeamManagement } = lazyImport(() => import('@/pages/TeamManagement'), 'TeamManagement');
const { Examine } = lazyImport(() => import('@/pages/Examine'), 'Examine');
const { Report } = lazyImport(() => import('@/pages/Report'), 'Report');
const { AppInfo } = lazyImport(() => import('@/pages/AppInfo'), 'AppInfo');
const { ApiConfig } = lazyImport(() => import('@/pages/ApiConfig'), 'ApiConfig');
const { AuthConfig } = lazyImport(() => import('@/pages/AuthConfig'), 'AuthConfig');
const { VerifyConfig } = lazyImport(() => import('@/pages/VerifyConfig'), 'VerifyConfig');
const { AppPublic } = lazyImport(() => import('@/pages/AppPublic'), 'AppPublic');
const { TestManagement } = lazyImport(() => import('@/pages/TestManagement'), 'TestManagement');
const { OperationsManagement } = lazyImport(
  () => import('@/pages/OperationsManagement'),
  'OperationsManagement'
);
const { ShippingMethod } = lazyImport(() => import('@/pages/ShippingMethod'), 'ShippingMethod');
const { NotFound } = lazyImport(() => import('@/pages/NotFound'), 'NotFound');
const { ActiveEmail } = lazyImport(() => import('@/pages/ActiveAuth'), 'ActiveEmail');
const { AppLog } = lazyImport(() => import('@/pages/AppLog'), 'AppLog');

const AppTypeMenu = [
  {
    path: '/app/report',
    name: 'report',
    element: <Report />,
  },
  {
    path: '/app/info',
    name: 'app_info',
    element: <AppInfo />,
  },
  {
    path: '/app/api_config',
    name: 'api_config',
    element: <ApiConfig />,
  },
  {
    path: '/app/auth_config',
    name: 'tit_create_one_15',
    element: <AuthConfig />,
  },
  {
    path: '/app/verify_config',
    name: 'verify_config',
    element: <VerifyConfig />,
  },
  {
    path: '/app/public',
    name: 'app_release',
    element: <AppPublic />,
  },
  {
    path: '/app/log',
    name: 'log',
    element: <AppLog />,
  },
  {
    path: '/app/test_accounts',
    name: 'test_gl',
    element: <TestManagement />,
  },
  {
    path: '/app/operations_management',
    name: 'operations_management',
    element: <OperationsManagement />,
  },
  {
    path: '/app/shipping_method',
    name: 'shipping_method',
    element: <ShippingMethod />,
  },
];

const config: RouteProps[] = [
  {
    path: '/',
    element: <BasicLayout />,
    children: [
      {
        path: '/',
        menu: true,
        name: 'tit_create_one_25',
        element: <ApplicationManagement />,
      },

      {
        path: '/create',
        name: 'app_manage',
        element: <ApplicationCreate />,
      },
      {
        path: '/team',
        menu: true,
        name: 'tit_create_one_26',
        element: <TeamManagement />,
      },
    ],
  },
  {
    path: '/app',
    name: 'tit_create_one_25',
    element: <AppLayout path="/app" />,
    children: AppTypeMenu,
  },
  {
    path: '/examine',
    name: 'Examine',
    element: (
      <RootLayout>
        <Examine />
      </RootLayout>
    ),
  },
  {
    path: '/active_email',
    element: <ActiveEmail />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

const routesConfig = config;

export { routesConfig };
